import React, { lazy, Suspense, useEffect, useState } from "react";
import "./Therapists.css";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/userSlice";
import { get, onValue, ref, update } from "firebase/database";
import { useNavigate } from "react-router-dom";
import { db } from "../../../firebaseConfig";

export default function Therapists({
  onSwitchSections,
  setIsTherapistProfile,
  isMobileView,
}) {
  const user = useSelector(selectUser);
  const navigate = useNavigate(); // Initialize navigate hook

  const TherapistCard = lazy(() => import("../components/TherapistCard"));

  const [therapists, setTherapists] = useState([]);
  const [showButton, setShowButton] = useState(true);
  const [isRedirecting, setIsRedirecting] = useState(false); // Add a flag to prevent multiple clicks

  useEffect(() => {
    window.scrollTo(0, 0);

    if (user) {
      const userClickCountRef = ref(db, `users/${user.uid}/clickCount`);

      // Retrieve the user's click count from Firebase
      onValue(userClickCountRef, (snapshot) => {
        const clickCount = snapshot.val() || 0;
        if (clickCount >= 2) {
          setShowButton(false);
        }
      });
    }

    // Subscribe to real-time updates for therapists
    const starCountRef = ref(db, "therapists");
    const unsubscribe = onValue(
      starCountRef,
      (snapshot) => {
        const data = snapshot.val();
        if (data) {
          setTherapists(Object.values(data));
        } else {
          console.log("No data available");
        }
      },
      (error) => {
        console.error("Error fetching data:", error);
      }
    );

    // Cleanup the subscription on component unmount
    return () => {
      unsubscribe();
    };
  }, [user]);

  const handleButtonClick = async () => {
    if (isRedirecting) return; // Prevent multiple clicks

    setIsRedirecting(true);

    if (user) {
      const userClickCountRef = ref(db, `users/${user.uid}/clickCount`);

      try {
        // Fetch the current click count
        const snapshot = await get(userClickCountRef);
        let clickCount = snapshot.val() || 0;

        // Increment the click count
        clickCount += 1;

        // Redirect the user to the consultation link
        window.location.href =
          "https://calendly.com/vibesandvent/20mins_consultation";

        // Update the click count in Firebase
        await update(ref(db, `users/${user.uid}`), { clickCount: clickCount });

        // After updating the click count, check if the button should be hidden
        if (clickCount >= 2) {
          setShowButton(false);
        }
      } catch (error) {
        console.error("Error updating click count:", error);
      } finally {
        setIsRedirecting(false);
      }
    } else {
      navigate("/registration");
    }
  };

  return (
    <div className={`therapists ${isMobileView && "mobile"}`}>
      <div className="therapists-container">
        <div className="therapists-header">
          {showButton && (
            <div className="login-btn" onClick={handleButtonClick}>
              BOOK A FREE CONSULATION SESSION
            </div>
          )}
        </div>
        <div className="therapists-content">
          {therapists.length > 0 &&
            therapists.map(
              (
                { photoURL, displayName, phone, email, bio, uid, workEmail },
                index
              ) => {
                if (
                  process.env.REACT_APP_AUTHORIZED_EMAILS?.split(",").includes(
                    user?.email
                  )
                ) {
                  return (
                    <Suspense
                      key={index}
                      fallback={<div className="fallback"></div>}
                    >
                      <TherapistCard
                        therapistUID={uid}
                        img={photoURL || ""}
                        bio={bio || ""}
                        name={displayName}
                        phone={phone || ""}
                        email={email}
                        workEmail={workEmail || null}
                        onSwitchSections={onSwitchSections}
                        setIsTherapistProfile={setIsTherapistProfile}
                      />
                    </Suspense>
                  );
                } else {
                  return (
                    photoURL &&
                    bio && (
                      <Suspense
                        key={index}
                        fallback={<div className="fallback"></div>}
                      >
                        <TherapistCard
                          therapistUID={uid}
                          img={photoURL || ""}
                          bio={bio || ""}
                          name={displayName}
                          phone={phone || ""}
                          email={email}
                          workEmail={workEmail || null}
                          onSwitchSections={onSwitchSections}
                          setIsTherapistProfile={setIsTherapistProfile}
                        />
                      </Suspense>
                    )
                  );
                }
              }
            )}
        </div>
      </div>
    </div>
  );
}
